import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {assignGuidToUser} from 'src/openapi/admin/apis/UserAuthenticationInfoApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    userId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useAssignGuid = ({userId, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback(() => apiDispatch(
        assignGuidToUser({userId}),
    ), [apiDispatch, userId]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
        onFail,
    });
};
